import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const AccessDeniedWrapper = styled.div`
  padding: 10px 16px;
  min-height: 100vh; /* full viewport height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .header {
    margin-top: 26px;
    text-align: center;
    color: ${COLORS.cirrus_black};
  }
  .subheader {
    margin-top: 24px;
    max-width: 400px;
    text-align: center;
    color: ${COLORS.cirrus_black};
  }
  .go-to-dashboard-button {
    margin-top: 24px;
  }

  .image {
    max-width: 252px;
    height: 284px;
    display: block;
  }
`;
